// extracted by css-extract-rspack-plugin
export default {"buttonBannerWrapper":"j1qOezTS","buttonBannerBadge":"utZ42w1H"};